import React from 'react';
import { StrapiMediaInfo } from '../apolloClient/types';
import {
  getSmallImageUrlFromImage,
  getLargeImageUrlFromImage,
} from 'lib/getImages';

export type PopUpGalleryProps = {
  openPopupLarge?: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      initialShowedIndex: number;
    }>
  >;
  images: StrapiMediaInfo[];
};

const PopUpGallery: React.FC<PopUpGalleryProps> = ({
  images,
  openPopupLarge,
}) => {
  // Chunk images into groups of 5
  const imageGroups = [];
  for (let i = 0; i < images.length; i += 5) {
    imageGroups.push(images.slice(i, i + 5));
  }

  const handleImageClick = (index: number) => {
    if (openPopupLarge) {
      openPopupLarge({ isOpen: true, initialShowedIndex: index });
    }
  };

  return (
    <div className="container-1280 h-full flex-1 min-h-0">
      {imageGroups.map((group, groupIndex) => {
        const baseIndex = groupIndex * 5;
        return (
          <div key={groupIndex} className="mb-4">
            {/* Two column grid for first 4 images */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              {group.slice(0, 4).map((image, idx) => (
                <div key={image.hash} className="relative w-full pt-[56.25%]">
                  <img
                    className="absolute top-0 left-0 w-full h-full object-cover cursor-pointer"
                    src={getLargeImageUrlFromImage(image)}
                    alt={image.name}
                    onClick={() => handleImageClick(baseIndex + idx)}
                  />
                </div>
              ))}
            </div>
            {/* Full width image */}
            {group[4] && (
              <div className="relative w-full pt-[56.25%]">
                <img
                  className="absolute top-0 left-0 w-full h-full object-cover cursor-pointer"
                  src={getLargeImageUrlFromImage(group[4])}
                  alt={group[4].name}
                  onClick={() => handleImageClick(baseIndex + 4)}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PopUpGallery;
